(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vanti-soft-ticker"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('vanti-soft-ticker'))customElements.define('vanti-soft-ticker',class extends HTMLElement{connectedCallback(){if(this.dataset.ready)return;this.dataset.ready='true';const group=this.querySelector('.vanti-soft-ticker__group');const track=this.querySelector('.vanti-soft-ticker__track');const button=this.querySelector('button');if(!group||!track||!button)return;const clone=group.cloneNode(true);clone.classList.add('vanti-soft-ticker__copy');clone.setAttribute('aria-hidden','true');clone.querySelectorAll('[data-shopify-editor-block]').forEach(el=>el.removeAttribute('data-shopify-editor-block'));track.append(clone);this.classList.add('ready');button.hidden=false;button.onclick=()=>{const paused=this.classList.toggle('paused');button.textContent=paused?button.dataset.resume:button.dataset.pause};this.observer=new ResizeObserver(()=>{const minimum=this.querySelector('.vanti-soft-ticker__window').clientWidth;group.style.minWidth=minimum+'px';clone.style.minWidth=minimum+'px';this.style.setProperty('--ticker-duration',Math.max(22,group.getBoundingClientRect().width/27)+'s')});this.observer.observe(this)}disconnectedCallback(){this.observer?.disconnect();this.querySelector('.vanti-soft-ticker__copy')?.remove()}});

  } catch(e) { console.error(e); }
})();
})();
